import React, {memo} from 'react';
import AuditReportDialog from './AuditReportDialog';

type Props = {
   onClose: () => void;
};

const AuditSummaryReportDialog = memo(({onClose}: Props) => {
   return <AuditReportDialog onClose={onClose} summary />;
});

export default AuditSummaryReportDialog;
